/**
 * 创建活动
 */
import { CREATEACTIVITY } from '../types';

export default {
    name: `${CREATEACTIVITY}`,
    path: '/createActivity',
    component: () => import(/* webpackChunkName: 'createActivity' */ '@/views/createActivity/'),
    redirect: { name: `${CREATEACTIVITY}Index` },
    meta: {
        title: '创建活动',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${CREATEACTIVITY}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'createActivity' */ '@/views/createActivity/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${CREATEACTIVITY}Create`,
        //     path: 'create',
        //     component: () => import(/* webpackChunkName: 'createActivity' */ '@/views/createActivity/create/Create.vue'),
        // },
    ],
};
